if (!customElements.get('quickbuy-variant-radios')) {
  class QuickbuyVariantRadios extends VariantSelects {
    constructor() {
      super();
      this.dataset.updateUrl = false;
      this.dataset.updateSwatch = false;
      this.dataset.updateVariantTitle = true;

      const showMore = this.querySelector('.quickbuy-form__show-more-variants');
      if (showMore) {
        showMore.addEventListener('click', this.toggleMoreVariants);
      }
    }

    get card() {
      return this.closest('.card-wrapper');
    }

    onVariantChange(event) {
      this.updateOptions(event);
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.removeErrorMessage();

      if (this.dataset.updateVariantTitle) {
        const variantTitle = this.querySelector('.quickbuy-form__variant-title');
        if (variantTitle && this.currentVariant) {
          variantTitle.innerHTML = this.currentVariant.title.replaceAll(' / Regular', '').replaceAll(' / Bundle', '');
        }
      }

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
        return;
      }

      this.updateMedia();
      this.updateVariantInput();
      this.renderProductInfo();
    }

    toggleMoreVariants(e) {
      e.preventDefault();
      const cardInfo = this.closest('.card-information');
      const variantContainer = cardInfo.querySelector('quickbuy-variant-radios fieldset');
      variantContainer.classList.toggle('active');
    }

    updateKlaviyoItem() {}

    updateShareUrl() {}

    updateURL() {}

    updateMedia() {
      if (!this.currentVariant || !this.currentVariant.featured_media || !this.card) return;

      const productId = this.dataset.productId;
      const newMedia = this.card.querySelectorAll(
        `[data-media-id="${productId}-${this.currentVariant.featured_media.id}"]`
      );

      newMedia.forEach((media) => {
        media.parentElement.prepend(media);
        media.classList.add('active');
      });
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }

    updateVariantInput() {
      const productForm = document.getElementById(this.dataset.productFormId);
      if (!productForm || !this.currentVariant) return;

      const input = productForm.querySelector('input[name="id"]');
      if (!input) return;

      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: false }));

      this.card?.querySelectorAll('a[href]').forEach((productLink) => {
        const href = productLink.getAttribute('href');
        if (!href) return;
        productLink.setAttribute(
          'href',
          href.includes('?variant')
            ? `${href.split('?')[0]}?variant=${this.currentVariant.id}`
            : `${href}?variant=${this.currentVariant.id}`
        );
      });
    }

    renderProductInfo() {
      this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
    }

    toggleAddButton(disable = true, text) {
      const productForm = document.getElementById(this.dataset.productFormId);
      if (!productForm) return;

      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] .product-form__add-button-text');
      if (!addButton) return;

      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text && addButtonText) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        if (addButtonText) addButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    setUnavailable() {
      const productForm = document.getElementById(this.dataset.productFormId);
      if (!productForm) return;

      const addButtonText = productForm.querySelector('[name="add"] .product-form__add-button-text');
      if (addButtonText) addButtonText.textContent = window.variantStrings.unavailable;
    }

    removeErrorMessage() {
      const productForm = this.card?.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }
  }

  customElements.define('quickbuy-variant-radios', QuickbuyVariantRadios);
}
